import moment from 'moment-timezone';
import i18n from '../Utils/i18n';
import { getSafeTimezone } from './MomentUtils';
import momentDurationFormatSetup from 'moment-duration-format';

export function getFormattedInterval(startTime, endTime, timeZone) {
  let tz = getSafeTimezone(timeZone);
  let fullDateTimeFormat = i18n.t('formatting.fullDayDateTimeWithMeridianCapital');
  let endTimeFormat = moment(startTime).isSame(moment(endTime), 'day')
    ? i18n.t('formatting.timeWithZone')
    : fullDateTimeFormat;
  let startTimeString = moment(startTime)
    .tz(tz)
    .format(fullDateTimeFormat);
  let endTimeString = moment(endTime)
    .tz(tz)
    .format(endTimeFormat);
  return `${startTimeString} - ${endTimeString}`;
}

export function getFormattedDateWithTimeZone(startTime, timeZone) {
  let tz = getSafeTimezone(timeZone);
  let fullDateTimeFormat = i18n.t('formatting.dateTimeWithZone');
  let startTimeString = moment(startTime)
    .tz(tz)
    .format(fullDateTimeFormat);
  return `${startTimeString}`;
}

export function getTimeInHrMin(lengthInMillis) {
  momentDurationFormatSetup(moment);
  return moment.duration(lengthInMillis, 'milliseconds').format(i18n.t('formatting.durationWithMinutes'), {
    trim: 'all'
  });
}

export function getTimeInHrMinAndSec(lengthInSeconds) {
  momentDurationFormatSetup(moment);
  return moment.duration(lengthInSeconds, 'seconds').format(i18n.t('formatting.timeWithSeconds'), {
    trim: 'both'
  });
}

export function getTimeInHrMinAndSecFromMillis(lengthInMillis) {
  momentDurationFormatSetup(moment);
  return moment.duration(lengthInMillis, 'milliseconds').format(i18n.t('formatting.timeWithSecondsShortForm'), {
    trim: 'both'
  });
}



// WEBPACK FOOTER //
// ./src/Utils/DateFormatUtils.js